import { FiasGeocodedApi, LeadContactsApi } from "../GeneratedApi";

export function getCenterCoordinates(setLocations:Function) {
   let link = 'https://rk.geosamara.ru/geosamara-demo-services/1.0.0/regions'
    fetch(link)
        .then(response => response.json())
        .then(data => setLocations(data));
}
export async function getSearchChilds(region: string, searchParent: string | undefined, input: string | undefined, setChilds: Function) {
    if (region) {
        let wrapper = async () => {
            return new Promise(
                (resolve, reject) => {
                    let base = new FiasGeocodedApi()
                    console.log('getSearchChilds', base)
                    resolve(base.getFiasHierarchy(region, searchParent, input))
                }
            )
        }
        let childs: any
        if (input && (input?.length > 1 || (!isNaN(parseInt(input)) && isFinite(parseInt(input))))) {
            childs = await wrapper()
            setChilds(childs.childs)
        }
    }

}

export async function getRegions(setRegions:Function) {
    let wrapper = async () => {
        return new Promise(
            (resolve, reject) => {
                let base = new LeadContactsApi()
                console.log('getSearchChilds', base)
                resolve(base.getRegions())
            }
        )
    }
    let regs = await wrapper()
    setRegions(regs)

}


export async function getGeometry(region: string, id: string | null | undefined, setGeometry: Function) {
    if (region) {
        let wrapper = async () => {
            return new Promise(
                (resolve, reject) => {
                    let base = new FiasGeocodedApi()
                    console.log('getGeometry', base)
                    resolve(base.getFiasGeometry(region, id))
                }
            )
        }
        let geom: any
        geom = await wrapper()
        if(geom.geometry) setGeometry(geom)
        else setGeometry(null)
    }

}